import { useEffect, useState } from "react";
import ProgressIcon from "../Assets/Icons/bold/clock.svg";
import CheckIcon from "../Assets/Icons/bold/tick-circle.svg";

const Switch = ({
  project_id,
  id,
  value,
  checkValue,
  noCheckValue,
  changeStatus,
  ...props
}) => {
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    if (value) {
      setChecked(true);
    }
  }, [value]);

  return (
    <label
      className="inline-flex items-center cursor-pointer relative"
      {...props}
    >
      <input
        type="checkbox"
        value={true}
        className="sr-only peer"
        onChange={(evt) => {
          setChecked(evt?.target?.checked);
          if (id) {
            changeStatus(project_id, id, evt?.target?.checked);
          }
        }}
        checked={checked}
      />
      <div
        className={`relative w-[30px] rounded-full text-white text-[11px] py-1.5 h-7 bg-red-800 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-red-300 peer-checked:after:translate-x-full border border-white after:content-[''] after:absolute after:top-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-6 after:w-6 after:transition-all peer-checked:bg-green-800 ${
          checked ? " ps-1 after:start-[-20px]" : " ps-7 after:start-[0px]"
        }`}
      >
        {/* {checked ? checkValue : noCheckValue} */}
      </div>
      <div
        className={`absolute after:transition-all ${
          checked ? "right-0" : "left-0"
        }`}
      >
        <img
          src={!checked ? ProgressIcon : CheckIcon}
          alt=""
          className="w-[25px] h-[25px] border border-white rounded-full"
        />
      </div>
    </label>
  );
};

export default Switch;
